/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var GridView = require('psa-marionette/views/GridView');
var UIUtil = require('psa-core/util/ui');

var MultiButtonCell = require('common/backgrid/MultiButtonCell');
var ConfirmationModalView = require('common/views/ConfirmationModalView');
var UpdateRecordsSalesCompensation = require('../services/UpdateRecordsSalesCompensation');

module.exports = GridView.extend({
  className: 'corp-fin-sales-comp-section-view',

  onBeforeRender: function() {
    if (GridView.prototype.onBeforeRender) {
      GridView.prototype.onBeforeRender.apply(this.arguments);
    }

    var isReadOnly = this.options.isReadOnly;

    this.options.columns = [
      {
        name: 'recipientNameDisplay',
        label: 'Recipient Name',
        cell: 'string',
        headerCell: 'custom',
        width: 20,
        editable: false
      },
      {
        name: 'recipientCRDDisplay',
        label: 'Recipient CRD',
        cell: 'string',
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'bdNameDisplay',
        label: 'BD Name',
        cell: 'string',
        headerCell: 'custom',
        width: 20,
        editable: false
      },
      {
        name: 'bdCRDDisplay',
        label: 'BD CRD',
        cell: 'string',
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'editDeleteMultiButtonCell',
        label: '',
        width: 10,
        cell: MultiButtonCell.extend({
          buttons: [
            {
              name: '',
              labelClass: 'fa fa-edit',
              buttonClass: 'btn-primary btn-sm edit-secondary-name',
              href: function(model) {
                return '#corpfin/exemption/' + model.get('recordId') + '/sales-comp/' + model.get('id') + '/edit';
              },
              renderable: function() {
                return !isReadOnly;
              }
            },
            {
              name: '',
              labelClass: 'fa fa-trash',
              buttonClass: 'btn-danger btn-sm delete-fee',
              onClick: this.onClickDeleteSalesCompensation.bind(this),
              renderable: function() {
                return !isReadOnly;
              }
            }
          ]
        }),
        editable: false,
        sortable: false
      }
    ];
    this.options.emptyText = 'No Sales Compensation';
  },

  onClickDeleteSalesCompensation: function(e, model) {
    e.preventDefault();
    var self = this;
    var message = 'Are you sure you want to delete this sales compensation?';
    UIUtil.showModal({
      title: 'Confirm Deleting Sales Compensation',
      view: new ConfirmationModalView({
        confirmText: 'Delete Sales Compensation',
        model: new Backbone.Model({
          message: message,
          onConfirm: function() {
            var salesCompensationId = model.get('id');
            return UpdateRecordsSalesCompensation({ id: salesCompensationId, isDeleted: '1' });
          },
          onConfirmDone: function() {
            self.collection.remove(model);
          }
        })
      })
    });
  }
});
